import { Option } from "../../util/option";
import { DisplayColumn, ErrorMessage } from "../../util/spreadsheet-data-utils";

export type PartnerDetailPageState = {
  /**
   * Partner Code List
   */
  searchResult: {
    ptnrInfo: PartnerInfo;
  };
  formValidation: FormValidation;
  manual: boolean;
  inboundSpreadsheetSelectedRowIndex: number | undefined;
  outboundSpreadsheetSelectedRowIndex: number | undefined;
  dataList: DataList;
  fieldPath: FieldPath;
  displayColumn: DisplayColumn[];
};

export type SpreadSheetMessage = {
  errorColumnList: string[];
  errorMessage: string;
  messageList: ErrorMessage[];
};

export type ChnTypeSpreadsheetRow = ChnType & SpreadSheetMessage;

export type SpreadsheetState = {
  chnTypeList: ChnTypeSpreadsheetRow[];
  inDefCommonFlagType: Option[];
  fileTypeType: Option[];
  targetEdiChainType: {
    label: string;
    value: string;
    godOnlyFlag: string;
  }[];
  inOutTypeCd: string;
  godFlg: string;
};

export type PartnerInfo = {
  ptnrId: string;
  ptnrCd: string;
  ptnrName: string;
  ptnrNameWtngChng: string;
  ptnrTypeCd: string;
  ptnrTypeName: string;
  buCnTypeCd: string;
  buCnTypeName: string;
  buCd: string;
  cnCd: string;
  dipByRgn: string;
  cpntId: string;
  delFlg: string;
  updtDtimePtnr: string;
  chnTypeList: ChnType[];
};

export type FormValidation = {
  ptnrCd: boolean;
  manual: boolean;
  ptnrName: boolean;
  ptnrNameWtngChng: boolean;
  buCnTypeCd: boolean;
  buCd: boolean;
  cnCd: boolean;
  dipByRgn: boolean;
  cpntId: boolean;
};

export type ChnType = {
  addRowFlg: string;
  chnTypeDelFlg: string;
  inOutTypeCd: string;
  inOutTypeName: string;
  chnTypeCd: string;
  chnTypeName: string;
  fileTypeCd: string;
  fileTypeName: string;
  updtDtimePtnrChnType: string;
};

export type DataList = {
  fileTypeType: Option[];
  inboundEdiChainType: {
    label: string;
    value: string;
    godOnlyFlag: string;
  }[];
  outboundEdiChainType: {
    label: string;
    value: string;
    godOnlyFlag: string;
  }[];
  ptnrType: Option[];
  ptnrBuCntryType: Option[];
  dipByRgn: Option[];
  cpntList: Option[];
  deleteRowFlg: Option[];
  inDefCommonFlagType: Option[];
};

type FieldPath = {
  ptnrCd: string;
  ptnrName: string;
  ptnrNameWtngChng: string;
  buCnTypeCd: string;
  buCd: string;
  cnCd: string;
  dipByRgn: string;
  cpntId: string;
};

export type PageNewState =
  | PartnerDetailPageState
  | ((prevState: PartnerDetailPageState) => PartnerDetailPageState);
